import React, { lazy, Suspense } from 'react';
import { Box, Typography, Chip, Paper, Tabs, Tab, CircularProgress } from '@mui/material';
import AIAssistantIcon from '@mui/icons-material/SmartToy';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AIAssistant from './AIAssistant';

const AICommandCenter = lazy(() => import('../modules/AICommandCenter'));
const AIManagement = lazy(() => import('../modules/AIManagement'));

function AIUnifiedSection({
  products, setProducts, clients, setClients,
  serviceOrders, setServiceOrders, warehouseOrders, setWarehouseOrders,
  calendarEvents, setCalendarEvents, createOrdersFromQuote,
  setSnackbar, setActiveSection, companyData, allOrders
}) {
  const [aiTab, setAiTab] = React.useState(0);

  return (
    <Box sx={{ maxWidth: 1400, mx: 'auto' }}>
      {/* Header */}
      <Box sx={{
        background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
        color: 'white', p: 2.5, borderRadius: '12px 12px 0 0',
        display: 'flex', alignItems: 'center', gap: 2
      }}>
        <AIAssistantIcon sx={{ fontSize: 32 }} />
        <Box sx={{ flex: 1 }}>
          <Typography variant="h5" sx={{ fontWeight: 700 }}>Asistente IA</Typography>
          <Typography variant="body2" sx={{ opacity: 0.85 }}>Centro de comando autónomo · Gestión · Simulador</Typography>
        </Box>
        <Chip label="En línea" size="small"
          sx={{ bgcolor: 'rgba(255,255,255,0.2)', color: 'white', fontWeight: 600 }}
          icon={<CheckCircleIcon sx={{ color: '#4ade80 !important' }} />}
        />
      </Box>

      {/* Tabs */}
      <Paper elevation={0} sx={{ borderRadius: 0, borderBottom: '1px solid #e2e8f0' }}>
        <Tabs value={aiTab} onChange={(_, v) => setAiTab(v)}
          sx={{
            px: 1,
            '& .MuiTab-root': { fontWeight: 600, textTransform: 'none', fontSize: '0.95rem', minHeight: 52 }
          }}
        >
          <Tab label="🎯 Centro de Comando" />
          <Tab label="📊 Gestión IA" />
          <Tab label="💬 Simulador Chat" />
        </Tabs>
      </Paper>

      {/* Tab 0: Centro de Comando AUTÓNOMO */}
      {aiTab === 0 && (
        <Paper elevation={0} sx={{ borderRadius: '0 0 12px 12px', overflow: 'hidden', border: '1px solid #e2e8f0', borderTop: 0 }}>
          <AICommandCenter
            products={products}
            setProducts={setProducts}
            clients={clients}
            setClients={setClients}
            serviceOrders={serviceOrders}
            setServiceOrders={setServiceOrders}
            warehouseOrders={warehouseOrders}
            setWarehouseOrders={setWarehouseOrders}
            calendarEvents={calendarEvents}
            setCalendarEvents={setCalendarEvents}
            createOrdersFromQuote={createOrdersFromQuote}
            setSnackbar={setSnackbar}
            setActiveSection={setActiveSection}
            companyData={companyData}
          />
        </Paper>
      )}

      {/* Tab 1: Gestión IA (métricas, historial, config) */}
      {aiTab === 1 && (
        <AIManagement products={products} clients={clients} orders={allOrders} />
      )}

      {/* Tab 2: Simulador de Chat del cliente */}
      {aiTab === 2 && (
        <Paper elevation={0} sx={{ borderRadius: '0 0 12px 12px', overflow: 'hidden', border: '1px solid #e2e8f0', borderTop: 0 }}>
          <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', gap: 1 }}>
            <AIAssistantIcon color="primary" />
            <Box>
              <Typography variant="subtitle2" sx={{ fontWeight: 'bold' }}>Simulador en Vivo</Typography>
              <Typography variant="caption" color="text.secondary">
                Prueba el flujo de ventas como si fueras un cliente real.
              </Typography>
            </Box>
          </Box>
          <Box sx={{ height: '65vh' }}>
            <AIAssistant products={products} clients={clients} orders={allOrders} />
          </Box>
        </Paper>
      )}
    </Box>
  );
}

export default AIUnifiedSection;
